<template>
	<div>
		<el-card>
			<div>
				<el-tabs v-model="dataForm.is_disable" @tab-click="event().handleClick()">
					<el-tab-pane label="正常" name="1"></el-tab-pane>
					<el-tab-pane label="封禁" name="2"></el-tab-pane>
				</el-tabs>
			</div>
			<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
				<el-form-item>
					<el-input style="width: 20rem;" v-model="dataForm.key" placeholder="请输入成员名称搜索" clearable
						suffix-icon="el-icon-search">
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-date-picker
						v-model="time"
						type="datetimerange"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:default-time="['12:00:00']"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="onChangeDateChange"
					></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="network().getUserTableList()">搜索</el-button>
					<el-button @click="event().clearSearch()">重置</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" @click="addAdminClick('新增')">新增成员
					</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" @click="downLoadTemp">下载模板
					</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<FileUploadVue @change='network().getUserTableList()'></FileUploadVue>
				</el-form-item>
				<!-- <el-form-item style="float: right;">
			    <el-button type="primary" @click="network().downloadUserTableExcel()">导出</el-button>
			  </el-form-item> -->
			</el-form>
			<el-table :data="tableData" border class="table-wrap"
				:header-cell-style="{background:'#eef1f6',color:'#606266'}" @selection-change="handleChange">
				<el-table-column prop="name" label="成员名称" width="100" align="center">
				</el-table-column>
				<el-table-column prop="identity" label="成员身份" align="center" width="200">
					<template slot-scope="scope">
						<el-tag type="success" v-if="scope.row.identity==1">用户</el-tag>
						<el-tag type="warning" v-else>管理员</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="account" label="账号" fit align="center">
				</el-table-column>
				 <el-table-column prop="phone" label="手机号" fit align="center">
				</el-table-column> 
				 <el-table-column prop="login_time" label="最后登录时间" fit align="center">
				</el-table-column> 
				 <el-table-column prop="login_count" label="累计登录次数" fit align="center">
				</el-table-column> 
				<el-table-column prop="create_time" label="创建时间" fit align="center">
				</el-table-column>
				<el-table-column label="操作" width="300px" align="center" fit>
					<template slot-scope="scope">
						<div class="operation-wrap">
							<span class="operation-item" style="color: #ff0000;" v-if="scope.row.is_disable == 1"
								@click="UserDisableClick(scope.row,2)">封禁</span>
							<span class="operation-item" v-if="scope.row.is_disable == 2"
								@click="UserDisableClick(scope.row,1)">解禁</span>
							<span class="operation-item" @click="resetPasswordClick(scope.row)">重置密码</span>
							<span class="operation-item" @click="editAdminClick(scope.row)">编辑</span>
							<span class="operation-item" @click="event().handleOperationClick(scope.row)">查看详情</span>
							<span class="operation-item delete" @click="deleteClick(scope.row)">
								<i class="el-icon-delete"></i>删除</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<!-- <el-form :inline="true" class="demo-form-inline">
			  <el-form-item>
			    <el-checkbox-group v-model="allChioce" @change="event().onAllChioceChange()">
			      <el-checkbox label="全选" name="type"></el-checkbox>
			    </el-checkbox-group>
			  </el-form-item>
			  <el-form-item>
			    <el-button v-if="dataForm.is_blacklist == 0" type="primary" @click="event().onBatchApprovalClick(1)">批量禁用
			    </el-button>
			    <el-button v-if="dataForm.is_blacklist == 1" type="primary" @click="event().onBatchApprovalClick(0)">批量解禁
			    </el-button>
			  </el-form-item>
			</el-form> -->

			<common-dialog :title="dialogTitle" :dialogVisible="dialogVisible" @cancel="dialogCancelClick"
				@confirm="dialogConfirmClick" @dialog-close="dialogClose">
				<div class="dialog-body-wrap">
					<div v-if="dialogType ==='delete'">
						是否删除用户？
					</div>
				</div>
			</common-dialog>

			<common-pagination :total="total" :page_size="page_size" :page_index="page_index"
				@page-change="handlePageChange" @size-change="handleSizeChange"></common-pagination>

			<UserDialog :uuid="selectForm" :dialogProp="editdialogVisible" @input="closeDialog"
				@confirm="confirmDialog">
			</UserDialog>
			<UserPasswordDialog :uuid="passwordForm" :dialogProp="passwordShow" @input="closeDialog"
				@confirm="confirmDialog">
			</UserPasswordDialog>
		</el-card>
	</div>
</template>

<script>
	import FileUploadVue from "../../../components/FileUpload.vue";
	import operations from "@/mixins/operations";
	import UserPasswordDialog from "./components/UserPasswordDialog.vue"
	import UserDialog from "./components/UserDialog.vue"
	import CommonPagination from "@/components/CommonPagination";
	import CommonDialog from "@/components/CommonDialog";
	import {
		getUserList,
		deleteUser,
		UserDisable
	} from "@/api/user-manage"
	import {
		mapState
	} from "vuex";
	import utils from "@/jslibs/utils"

	export default {
		name: "hotellist",
		mixins: [operations],
		data() {
			return {
				total: 0,
				page_size: 10,
				page_index: 1,
				tableData: [],
				selectedTabIndex: "1",
				dataForm: {
					key: "",
					is_disable: '1',
					startTime: '',
					endTime: ''
				},
				showDialog: false,
				showDialogType: "Authentication",
				showDialogTitle: '',
				cancelBtnText: "",
				userAuthInfo: {},
				tabList: [{
						label: '正常',
						value: 1
					},
					{
						label: '禁用',
						value: 2
					}
				],
				allChioce: [],
				allSelectIdList: [],
				selectForm: {},
				editdialogVisible: false,
				//删除弹框开始
				dialogTitle: "",
				dialogType: "",
				dialogVisible: false,
				form: {},
				//删除弹框结束
				passwordShow: false,
				passwordForm: {},
				time: [],
			};
		},
		components: {
			CommonPagination,
			UserDialog,
			UserPasswordDialog,
			CommonDialog,
			FileUploadVue
		},
		mounted() {
			this.network().getUserTableList();
		},
		computed: {
			...mapState(["imgDomain"])
		},
		methods: {
			downLoadTemp(){
				window.location.href = 'https://gymoo-project-cdn.oss-cn-shenzhen.aliyuncs.com/innovation/%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
			},
			resetPasswordClick(row) {
				this.passwordShow = true;
				this.passwordForm = row;
			},
			async UserDisableClick(item, is_disable) {
				const {
					status
				} = await UserDisable({
					id: item.uuid,
					is_disable: is_disable
				});
				this.$message.success('操作成功')
				if (status === 200) {
					this.network().getUserTableList();
				}
			},
			//删除弹框开始
			dialogCancelClick: () => {
				this.dialogVisible = false
			},
			async dialogConfirmClick() {
				if (this.dialogType === "delete") {
					let postData = {
						id: this.form.uuid
					}
					const {
						status
					} = await deleteUser(postData);
					this.$message.success('删除成功')
					if (status === 200) {
						this.dialogVisible = false;
						return;
					}
				}
			},
			dialogClose() {
				this.dialogVisible = false;
				this.network().getUserTableList();
			},
			deleteClick(row) {
				this.form = JSON.parse(JSON.stringify(row));
				this.dialogVisible = true;
				this.dialogType = "delete";
				this.dialogTitle = "删除用户";
			},
			//删除弹框结束
			closeDialog(row) {
				this.passwordShow = false
				this.editdialogVisible = false;
			},
			confirmDialog(row) {
				this.editdialogVisible = row;
				this.network().getUserTableList()
			},
			onChangeDateChange() {
				this.dataForm.startTime = this.time && this.time.length ? this.time[0] : ''
				this.dataForm.endTime = this.time && this.time.length ? this.time[1] : ''
			},

			//添加
			addAdminClick() {
				this.selectForm = {};
				this.selectForm.role_uuid = this.uuid
				this.editdialogVisible = true;
			},
			//修改
			editAdminClick(row) {
				this.editdialogVisible = true;
				this.selectForm = row;
				this.selectForm.role_uuid = this.uuid
			},
			handleChange(row) {
				this.allSelectIdList = row.map(item => item.user_id);
			},
			tabChange(e) {
				this.dataForm.status = e
				this.network().getUserTableList();
			},
			/**文件上传选择完成时触发的事件函数**/
			onFileChange(e) {
				let file = e.target.file[0]
			},
			handlePageChange(page) {
				this.event().handlePageChange(page);
			},
			handleSizeChange(size) {
				this.event().handleSizeChange(size);
			},
			/**
			 *触摸，响应事件放在event下，如onclick函数,onchange函数等
			 *特殊情况:像一些需要接收参数的事件，如onchange原生事件或者是vue中的emit有参数的事件,必须得写在event外部，否则无法得到接收参数。像这种事件特殊处理
			 **/
			event() {
				return {
					clearSearch: () => {
						this.dataForm.key = ''
						this.dataForm.parent_id = ''
						this.dataForm.startTime = ''
						this.dataForm.endTime = ''
						this.time = []
						this.page_index = 1
						this.network().getUserTableList();
					},
					handleClick: () => {
						this.network().getUserTableList();
					},
					toggleTab: (index) => {
						this.allChioce = [];
						this.dataForm.is_blacklist = index
						this.network().getUserTableList();
					},
					/**
					 * 点击全选
					 * @param {Object} index
					 */
					onAllChioceChange: (row) => {
						//全选将List中的id提取出来
						this.allSelectIdList = row.map(item => item.user_id);
					},
					/**
					 * 已认证用户点击
					 */
					onShowDialogClick: (btn, data) => {
						this.showDialog = true;
						this.showDialogType = btn;
						this.userAuthInfo = data;
						this.showDialogTitle = '认证信息';
						this.cancelBtnText = "返回"
					},
					onCloseModalClick: () => {
						this.showDialog = false;
					},
					/**
					 * 查看用户详情
					 */
					handleOperationClick: (data) => {
						this.$router.push({
							path: "/user-detail?uuid=" + data.uuid
						})
					},
					/**
					 * 解禁/禁用
					 * @param {Object} uuid
					 */
					handleIsDisableclick: (uuid, is_blacklist) => {
						// var uuidList = uuid.split(",");
						this.network().newWorkIsDisableClick(uuid, is_blacklist);
					},
					handlePageChange: (page) => {
						this.page_index = page;
						this.network().getUserTableList();
					},
					handleSizeChange: (size) => {
						this.page_size = size;
						this.network().getUserTableList();
					},
					onBatchApprovalClick: (isDisable) => {
						if (this.allSelectIdList.length > 0) {
							if (isDisable) { // true 解
								this.network().batchUnDisable()
							} else {
								this.network().batchDisable()
							}
						} else {
							this.$message.error('请点击全选选项');
						}
					},
				}
			},
			/**
			 *网络访问相关函数
			 **/
			network() {
				return {
					getUserTableList: async () => {

						let postData = {
							page_size: this.page_size,
							page_index: this.page_index,
							keyword_search: this.dataForm.key,
							is_disable: this.dataForm.is_disable,
							start_time: this.dataForm.startTime,
							end_time: this.dataForm.endTime
						};
						const {
							status,
							data
						} = await getUserList(postData);
						if (status !== 200) return;
						this.tableData = data.result.data;
						this.total = data.result.total;
					},

					batchDisable: async () => {
						let postData = {
							user_ids: this.allSelectIdList
						}
						const {
							status,
							data
						} = await batchDisable(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},
					batchUnDisable: async () => {
						let postData = {
							user_ids: this.allSelectIdList
						}
						const {
							status,
							data
						} = await batchUnDisable(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},


					disableUser: async (row) => {
						let postData = {
							user_id: row.user_id
						}
						const {
							status,
							data
						} = await disableUser(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},

					ableUser: async (row) => {
						let postData = {
							user_id: row.user_id
						}
						const {
							status,
							data
						} = await ableUser(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},
				}
			},
			/**
			 * 一般放处理业务逻辑较多的私人函数
			 **/
			handler() {
				return {
					handleListA(list) {
						for (var i = 0; i < list.length; i++) {
							//handle service
						}
					},
					/**
					 **校验表单输入
					 **/
					verifyInput() {},

				}
			}

		}
	};
</script>

<style lang="less" scoped>
	@import "~@/assets/styles/variables.less";
	@import "~@/assets/styles/mixins.less";

	.table-wrap {
		.table-wrap(5px);
	}

	.m-content {
		width: 12rem;
	}

	.m-tab {
		position: relative;
		margin-bottom: 2.1875rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.m-tab-item {
		padding-right: 2.0625rem;
		color: #8D8EA6;
		font-size: 1.375rem;
		text-align: center;
	}

	.m-tab-item-active {
		color: #409eff;
	}

	.tab-line {
		height: 2px;
		background: #409eff;
		position: absolute;
		bottom: 0;
		transition: all 0.3s ease;
	}

	.tab-line-0 {
		width: 3rem;
		left: 0;
	}

	.tab-line-1 {
		width: 5rem;
		left: 1;
	}
</style>